const handleInitPostBlockSlider = ({ id }) => {
  const pageWidth = document?.body?.offsetWidth;
  const isDesktop = pageWidth > DESKTOP_WIDTH;
  const productCountTarget = isDesktop ? 4 : 2;
  const carouselId = `post-block-carousel-${id}`;
  const carouselElement = document?.getElementById(carouselId);
  const { productCount } = carouselElement.dataset;
  const isEnabledAsBool = productCount > productCountTarget;
  const paginationId = `swiper-pagination-${id}`;
  const paginationEnabled = isEnabledAsBool && {
    pagination: {
      el: `#${paginationId}`,
      type: 'bullets',
    },
  };

  const navigationEnabled = isEnabledAsBool && {
    navigation: {
      nextEl: `#swiper-button-next-${id}`,
      prevEl: `#swiper-button-prev-${id}`,
    },
  };

  if (!carouselElement) {
    return null;
  }

  if (!isEnabledAsBool) {
    const navigationWrapper = document.getElementById(
      `swiper-navigation-wrapper-${id}`
    );

    navigationWrapper?.classList?.add('!hidden');
  }

  const swiper = new Swiper(`#${carouselId}`, {
    speed: DEFAULT_SLIDER_SPEED,
    spaceBetween: 4,
    loop: false,
    slidesPerView: 1.5,
    centeredSlides: false,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      [DESKTOP_WIDTH]: {
        slidesPerView: 4.5,
        spaceBetween: 16,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
      },
    },
    ...navigationEnabled,
    ...paginationEnabled,
    on: {
      init: function () {
        this?.el?.classList.remove('opacity-0');
        this?.wrapperEl?.classList.remove(
          'items-center',
          'justify-center',
          'gap-4'
        );
      },
    },
    watchOverflow: true,
  });

  return swiper;
};

const handleInitPostBlock = () => {
  const swiperElement = document?.querySelectorAll('.js-post-block-slider');

  if (swiperElement?.length == 0) {
    return null;
  }

  swiperElement.forEach((element) => {
    handleInitPostBlockSlider({
      id: element.dataset.id,
    });
  });
};

handlePageLoadEvent(handleInitPostBlock);
handleShopifyEditorEvent(handleInitPostBlock);
